import React from 'react';
import { breakpoint, spacer4, cssColorValue, semanticColors, spacer8, desktopViola, mobileViola, desktopFinaleBold, mobileFinaleBold, spacer12, desktopBallad, mobileBallad, IconChevronUp, IconChevronDown, ButtonIcon, IconX } from '@spotify-internal/encore-web';
import { components } from 'react-select';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var overlayBoxShadow = "0 ".concat(spacer4, " ").concat(spacer12, " 0 rgba(0, 0, 0, 0.2)"); // overlayBoxShadow from @spotify-internal/encore-web/src/styles/mixins/overlays.tsx

var opacityDisabled = '0.3'; // opacityDisabled from @spotify-internal/encore-web/src/styles/variables.tsx

var cursorDisabled = 'not-allowed'; // cursorDisabled from @spotify-internal/encore-web/src/styles/variables.tsx

// copied from src/core/styles/mixins/type.tsx in @spotify-internal/encore-web
var responsiveTypeVariant = function responsiveTypeVariant(mobileTypeStyle, desktopTypeStyle) {
  return _objectSpread(_objectSpread({}, mobileTypeStyle), {}, _defineProperty({
    fontSize: mobileTypeStyle.fontSize
  }, "@media (min-width: ".concat(breakpoint.screenSmMin, ")"), _objectSpread(_objectSpread({}, desktopTypeStyle), {}, {
    fontSize: desktopTypeStyle.fontSize
  })));
};

function getControlStyles(_ref) {
  var _customStyles$control;

  var provided = _ref.provided,
      state = _ref.state,
      isUsingKeyboard = _ref.isUsingKeyboard,
      error = _ref.error,
      customStyles = _ref.customStyles;
  var focusStyles = {
    boxShadow: "inset 0 0 0 ".concat(isUsingKeyboard ? 3 : 1.5, "px ").concat(cssColorValue(semanticColors.essentialBase))
  };
  var disabledStyles = {
    boxShadow: "inset 0 0 0 1px ".concat(cssColorValue(semanticColors.essentialSubdued)),
    opacity: opacityDisabled,
    cursor: cursorDisabled
  };
  var errorStyles = {
    boxShadow: "inset 0 0 0 1px ".concat(cssColorValue(semanticColors.essentialNegative))
  };
  var focusedErrorStyles = {
    boxShadow: "inset 0 0 0 ".concat(isUsingKeyboard ? 3 : 1.5, "px ").concat(cssColorValue(semanticColors.essentialNegative))
  };

  var pseudoStyles = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, state.isFocused ? focusStyles : {}), error ? errorStyles : {}), error && state.isFocused ? focusedErrorStyles : {}), state.isDisabled ? disabledStyles : {});

  var hoverStyles = {
    ':hover': _objectSpread({
      boxShadow: "inset 0 0 0 1px ".concat(cssColorValue(semanticColors.essentialBase))
    }, pseudoStyles)
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, provided), responsiveTypeVariant(mobileBallad, desktopBallad)), {}, {
    padding: 0,
    border: 0,
    outline: 0,
    borderRadius: spacer4,
    transition: "box-shadow ease-in-out 0.1s, color ease-in-out 0.1s",
    backgroundColor: "".concat(cssColorValue(semanticColors.backgroundBase)),
    color: "".concat(cssColorValue(semanticColors.textBase)),
    boxShadow: "inset 0 0 0 1px ".concat(cssColorValue(semanticColors.essentialSubdued))
  }, hoverStyles), pseudoStyles), customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$control = customStyles.control) === null || _customStyles$control === void 0 ? void 0 : _customStyles$control.call(customStyles, provided, state));
}

var getEncoreStyles = function getEncoreStyles(_ref2) {
  var isUsingKeyboard = _ref2.isUsingKeyboard,
      error = _ref2.error,
      _ref2$customStyles = _ref2.customStyles,
      customStyles = _ref2$customStyles === void 0 ? {} : _ref2$customStyles;
  return _objectSpread(_objectSpread({}, customStyles), {}, {
    control: function control(provided, state) {
      return getControlStyles({
        provided: provided,
        state: state,
        isUsingKeyboard: isUsingKeyboard,
        error: error,
        customStyles: customStyles
      });
    },
    valueContainer: function valueContainer(provided, state) {
      var _customStyles$valueCo;

      return _objectSpread(_objectSpread({}, provided), {}, {
        margin: 0,
        gap: spacer4,
        minHeight: state.isMulti ? '52px' : provided.minHeight,
        padding: state.isMulti ? '10px 14px' : '14px',
        paddingRight: 0
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$valueCo = customStyles.valueContainer) === null || _customStyles$valueCo === void 0 ? void 0 : _customStyles$valueCo.call(customStyles, provided, state));
    },
    placeholder: function placeholder(provided, state) {
      var _customStyles$placeho;

      return _objectSpread(_objectSpread({}, provided), {}, {
        margin: 0,
        color: cssColorValue(semanticColors.textSubdued)
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$placeho = customStyles.placeholder) === null || _customStyles$placeho === void 0 ? void 0 : _customStyles$placeho.call(customStyles, provided, state));
    },
    input: function input(provided, state) {
      var _customStyles$input;

      return _objectSpread(_objectSpread({}, provided), {}, {
        margin: 0,
        padding: 0
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$input = customStyles.input) === null || _customStyles$input === void 0 ? void 0 : _customStyles$input.call(customStyles, provided, state));
    },
    clearIndicator: function clearIndicator(provided, state) {
      var _customStyles$indicat;

      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: 0
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$indicat = customStyles.indicatorSeparator) === null || _customStyles$indicat === void 0 ? void 0 : _customStyles$indicat.call(customStyles, provided, state));
    },
    indicatorSeparator: function indicatorSeparator(provided, state) {
      var _customStyles$indicat2;

      return _objectSpread({}, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$indicat2 = customStyles.indicatorSeparator) === null || _customStyles$indicat2 === void 0 ? void 0 : _customStyles$indicat2.call(customStyles, provided, state));
    },
    // Hide separator unless overrides say otherwise
    dropdownIndicator: function dropdownIndicator(provided, state) {
      var _customStyles$dropdow;

      return _objectSpread(_objectSpread({}, provided), {}, {
        color: cssColorValue(semanticColors.essentialSubdued),
        padding: '14px',
        pointerEvents: 'none'
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$dropdow = customStyles.dropdownIndicator) === null || _customStyles$dropdow === void 0 ? void 0 : _customStyles$dropdow.call(customStyles, provided, state));
    },
    menu: function menu(provided, state) {
      var _customStyles$menu;

      return _objectSpread(_objectSpread({}, provided), {}, {
        background: cssColorValue(semanticColors.backgroundElevatedBase),
        color: cssColorValue(semanticColors.textBase),
        borderRadius: spacer8,
        boxShadow: overlayBoxShadow,
        overflow: 'hidden'
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$menu = customStyles.menu) === null || _customStyles$menu === void 0 ? void 0 : _customStyles$menu.call(customStyles, provided, state));
    },
    menuList: function menuList(provided, state) {
      var _customStyles$menuLis;

      return _objectSpread(_objectSpread({}, provided), {}, {
        margin: 0,
        padding: 0,
        maxHeight: '273px',
        // DropdownList styles
        paddingBlockStart: spacer8,
        paddingBlockEnd: spacer8
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$menuLis = customStyles.menuList) === null || _customStyles$menuLis === void 0 ? void 0 : _customStyles$menuLis.call(customStyles, provided, state));
    },
    option: function option(provided, state) {
      var _customStyles$option;

      return _objectSpread(_objectSpread(_objectSpread({}, provided), responsiveTypeVariant(mobileViola, desktopViola)), {}, {
        padding: '14px 16px',
        color: state.isSelected ? cssColorValue(semanticColors.textBase) : cssColorValue(semanticColors.textSubdued),
        // Link styles in DropdownLink
        '&:hover': !state.isSelected ? {
          backgroundColor: cssColorValue(semanticColors.backgroundTintedHighlight),
          color: cssColorValue(semanticColors.textSubdued)
        } : {},
        // eslint-disable-next-line no-nested-ternary
        backgroundColor: state.isSelected ? cssColorValue(semanticColors.backgroundTintedBase) : state.isFocused ? cssColorValue(semanticColors.backgroundTintedHighlight) : 'transparent',
        // Link styles in DropdownLink
        '&:active': {
          color: cssColorValue(semanticColors.textSubdued),
          backgroundColor: cssColorValue(semanticColors.backgroundTintedPress)
        }
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$option = customStyles.option) === null || _customStyles$option === void 0 ? void 0 : _customStyles$option.call(customStyles, provided, state));
    },
    singleValue: function singleValue(provided, state) {
      var _customStyles$singleV;

      return _objectSpread(_objectSpread({}, provided), {}, {
        margin: 0,
        color: cssColorValue(semanticColors.textBase)
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$singleV = customStyles.singleValue) === null || _customStyles$singleV === void 0 ? void 0 : _customStyles$singleV.call(customStyles, provided, state));
    },
    multiValue: function multiValue(provided, state) {
      var _customStyles$multiVa;

      return _objectSpread(_objectSpread({}, provided), {}, {
        margin: 0,
        backgroundColor: cssColorValue(semanticColors.backgroundTintedBase),
        borderRadius: spacer4
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$multiVa = customStyles.multiValue) === null || _customStyles$multiVa === void 0 ? void 0 : _customStyles$multiVa.call(customStyles, provided, state));
    },
    multiValueLabel: function multiValueLabel(provided, state) {
      var _customStyles$multiVa2;

      return _objectSpread(_objectSpread(_objectSpread({}, provided), responsiveTypeVariant(mobileFinaleBold, desktopFinaleBold)), {}, {
        color: cssColorValue(semanticColors.textBase)
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$multiVa2 = customStyles.multiValueLabel) === null || _customStyles$multiVa2 === void 0 ? void 0 : _customStyles$multiVa2.call(customStyles, provided, state));
    },
    multiValueRemove: function multiValueRemove(provided, state) {
      var _customStyles$multiVa3;

      return _objectSpread(_objectSpread({}, provided), {}, {
        display: state.isDisabled ? 'none' : provided.display,
        '&:hover': {
          color: cssColorValue(semanticColors.textBase),
          backgroundColor: cssColorValue(semanticColors.backgroundTintedHighlight),
          borderRadius: "0 ".concat(spacer4, " ").concat(spacer4, " 0")
        }
      }, customStyles === null || customStyles === void 0 ? void 0 : (_customStyles$multiVa3 = customStyles.multiValueRemove) === null || _customStyles$multiVa3 === void 0 ? void 0 : _customStyles$multiVa3.call(customStyles, provided, state));
    }
  });
};

var DropdownIndicator = function DropdownIndicator(props) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, props.isFocused ? /*#__PURE__*/React.createElement(IconChevronUp, {
    iconSize: 16
  }) : /*#__PURE__*/React.createElement(IconChevronDown, {
    iconSize: 16
  }));
};

var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/React.createElement(components.ClearIndicator, props, /*#__PURE__*/React.createElement(ButtonIcon, null, /*#__PURE__*/React.createElement(IconX, {
    iconSize: 16,
    "aria-label": "Close"
  })));
};

var MultiValueRemove = function MultiValueRemove(props) {
  return /*#__PURE__*/React.createElement(components.MultiValueRemove, props, /*#__PURE__*/React.createElement(IconX, {
    iconSize: 16,
    "aria-label": "Close",
    semanticColor: semanticColors.textSubdued
  }));
};

export { ClearIndicator as C, DropdownIndicator as D, MultiValueRemove as M, getEncoreStyles as g };
